module.exports = __webpack_public_path__ + "img/cw.69f19c22.svg";